module.exports = __webpack_public_path__ + "media/images/bannerImage5-61486d87beae480bca6b4e13d4367ec7.jpg";